import React from "react";

import "./Navigator.css";

const Navigator = () => {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth"
    });
  };

  return (
    <>
      <div className="boxxx" onClick={handleClick}></div>
    </>
  );
};

export default Navigator;
